// extracted by mini-css-extract-plugin
export default {"CheckboxContainer":"📚19-10-2lzBQ7","Checkbox":"📚19-10-2_zm4g","Check":"📚19-10-2_TWEJ"};